import { createSelector } from 'reselect'
import { memoize } from 'lodash' // eslint-disable-line @exodus/restricted-imports/prefer-basic-utils -- TODO: fix next time we touch this file
import { FiatOrderSet } from '@exodus/models'

const selectorFactory = (visibleOrdersSelector) =>
  memoize((type) =>
    createSelector(visibleOrdersSelector, (fiatOrders) =>
      FiatOrderSet.fromArray([...fiatOrders].filter(({ orderType }) => orderType === type))
    )
  )

const createVisibleOrdersByTypeSelectorDefinition = {
  id: 'createVisibleOrdersByType',
  selectorFactory,
  dependencies: [
    //
    { selector: 'visibleOrders' },
  ],
}

export default createVisibleOrdersByTypeSelectorDefinition
